
import React from 'react';
import 'jquery';
import 'foundation-sites';
import logo from '../BAE_Logo.svg';
import era from '../era.png';

const Footer = () => {
    return (
        <div className="footer-container">
<footer className="footer">
<section className="footer-container">
  <div className="grid-container">
    <div className="grid-x grid-margin-x padding-top-large">
      <div className="small-12 large-6 cell">
        <a href="https://baesystems.com" target="_blank">
          <img src={logo} alt="bae systems" width="200px"/>
        </a>
        <p className="padding-top-large">© 2025 BAE Systems | All Rights Reserved </p>
        <p>
          <a href="https://accessibility.baesystems.com/mcmw" target="_blank">Accessibility</a> | <a href="https://www.baesystems.com/en/terms-and-conditions" target="_blank">Conditions of Use</a> | <a href="https://www.baesystems.com/en/privacy" target="_blank">Privacy Policy</a> | <a href="https://www.baesystems.com/en/cookie-policy" target="_blank">Cookie Policy</a></p>
        </div>
      </div>
    </div>
  </section>
</footer> 
                     
                    
</div>
                    );
    };
    
export default Footer;